/**
 * `last_updated` — monday offers the identical list to `creation_log` (measured side by side
 * on the sandbox board), so the table lives once, in `creation-log/filters.ts`.
 */
import { personAndDateFilterConditions } from '../creation-log/filters.js';
export const lastUpdatedFilterConditions = personAndDateFilterConditions;
//# sourceMappingURL=filters.js.map